<template>

  <CabinetInner v-if="$store.state.main.userData !== null" />

</template>

<script>

import CabinetInner from '@/components/CabinetInner';
export default {
  components: {CabinetInner},

}
</script>

<style lang="scss">
.cabinet-fadeup-enter-active,
.cabinet-fadeup-leave-active {
  transition: all 1s;
  
}
.cabinet-fadeup-enter,
.cabinet-fadeup-leave-to {
    transform: translateX(10px);
  opacity: 0;
 // transform: translateY(100%);
}

.cabinet{
   .el-input__inner {
            border: none;
            background-color: transparent;
            color: #101820;
            font-family: "FiraGO-Bold";
            font-size: 21px;
            padding-left: 0;
            padding-right: 0;
            width: 100%;
        }
        .el-select-dropdown {
            position: absolute;
            z-index: 1001;
            border: 1px solid #E4E7ED;
            border-radius: 4px;
            background-color: #FFF;
            box-sizing: border-box;
            margin: 5px 0;
        }
        .el-popper[x-placement^=bottom] .popper__arrow {
            display: none;
        }
        .el-popper[x-placement^=bottom] {
            margin-top: 10px;
        }
        .el-select-dropdown__item {
            will-change: transform;
            background-color: white;
            span {
                color: #101820;
                font-family: "FiraGO-Bold";
                font-size: 16px;
                will-change: transform;
            }
            &:hover,
            &.hover {
                background-color: white;
            }
        }
        .el-input__icon {
            width: 15px;
        }
        
    }

</style>